import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "../../utils/UserContext";
import { useProperty } from "../../utils/PropertyContext";
import Logo from "../../assets/logotipo secundario - alfa tabelas.png";
import { FaStar, FaSearch, FaUserCircle, FaBars } from "react-icons/fa";
import { CiSearch } from "react-icons/ci";
import "./styles/horizontalBar.css";

export default function HorizontalBar({ toggleMenu }) {
  const [search, setSearch] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [filteredDropdownData, setFilteredDropdownData] = useState([]);
  const inputRef = useRef(null);
  
  const { currentUser, isLoading } = useUser();
  // Pegando as funções corretas do PropertyContext
  const { fetchApprovedProperties, realEstatesMap, fetchRealEstatesMap } = useProperty();
  const navigate = useNavigate();

  useEffect(() => {
    fetchRealEstatesMap();
  }, [fetchRealEstatesMap]);

useEffect(() => {
  const delayDebounceFn = setTimeout(async () => {
    if (search.trim()) {
      const results = await fetchApprovedProperties({ 
        filtersParam: { search: search.trim() },
        pageParam: 1 
      });
      setFilteredDropdownData(results || []);
    } else {
      setFilteredDropdownData([]);
    }
  }, 300);
  return () => clearTimeout(delayDebounceFn);
}, [search, fetchApprovedProperties]);

  const handleShowSearchBar = () => {
    setShowSearchBar((prevState) => !prevState);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setShowDropdown(false);
        setShowSearchBar(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSearchSubmit = async (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const searchTerm = search.trim();
      if (searchTerm !== "") {
        try {
          navigate("/dashboard/imoveis/busca", {
            state: {
              searchTerm: searchTerm,
            },
          });
          setSearch("");
          setShowDropdown(false);
        } catch (error) {
          console.error("Erro ao submeter busca:", error);
        }
      }
    }
  };

  const formatarComissao = (valor) => {
    if (valor === null || valor === undefined || valor === "") {
      return "Não Informado";
    }
    const numValor = parseFloat(valor);
    if (numValor === 0 || Number(valor) === 999) {
      return "Fifty";
    }
    const v = String(valor).trim().toLowerCase();
    if (v === "fifty") {
      return "Fifty";
    }
    const num = parseFloat(v);
    if (isNaN(num)) {
      return valor;
    }
    if (num > 0 && num < 1) {
      return `${(num * 100).toFixed(0)}%`;
    }
    return `${num}%`;
  };

  return (
    <header className="horizontal-bar">
      <div className="hamburger-container" onClick={toggleMenu}>
        <FaBars />
      </div>

      <Link
        to={"/dashboard/imoveis/favoritos/"}
        className="container-favorite-guide"
      >
        <i>
          <FaStar />
        </i>
      </Link>

      {!showSearchBar && (
        <img src={Logo} alt="Logotipo" className="logo-mobile" />
      )}

      <div
        className={`container-icon-search-mobile ${
          !showSearchBar ? "active" : ""
        }`}
      >
        <i onClick={handleShowSearchBar}>
          <FaSearch />
        </i>
      </div>

      <div
        className={`container-search-bar ${showSearchBar ? "active" : ""}`}
        ref={inputRef}
      >
        <div className="field-search-bar">
          <i>
            <CiSearch />
          </i>

          <input
            type="text"
            placeholder="Busque por Bairro, Responsável, 2 vagas, 3 dorms..."
            value={search}
            onFocus={() => setShowDropdown(true)}
            onChange={(event) => setSearch(event.target.value)}
            onKeyDown={handleSearchSubmit}
          />

          {search && (
            <button className="clear-button" onClick={() => setSearch("")}>
              x
            </button>
          )}
        </div>

        {showDropdown && search && (
          <ul
            className={`suspense-bar ${showDropdown ? "show" : ""}`}
            style={{
              maxHeight: "500px",
              overflowY: filteredDropdownData.length > 6 ? "auto" : "unset",
            }}
          >
            {filteredDropdownData.length === 0 && (
              <li>
                <p>Nenhum imóvel com essas características encontrado</p>
              </li>
            )}

            {filteredDropdownData.map((item, index) => (
              <li
                key={index}
                onClick={() => {
                  setSearch("");
                  setShowDropdown(false);
                }}
              >
                <Link
                  to={`/dashboard/imoveis/${item.id}/`}
                  className="item-suspense-bar"
                >
                  <img
                    src={
                      item.imagens?.[0] ||
                      "https://www.zapimoveis.com.br/blog/wp-content/uploads/2024/10/o-que-fazer-em-praia-grande.jpg"
                    }
                    alt={`Imagem do imóvel ${item.tipoImovel}`}
                  />

                  <div className="item-details">
                    <p className="item-title">
                      {item.tipoImovel === "Apartamento"
                        ? "APTO."
                        : (item.tipoImovel || "").toUpperCase()}{" "}
                      {item.dorms}{" "}
                      {item.dorms === 1 ? "DORMITÓRIO" : "DORMITÓRIOS"} -{" "}
                      {item.nomeResidencial
                        ? (item.nomeResidencial || "").toUpperCase() + " - "
                        : ""}
                      {(item.bairro || "").toUpperCase()}
                    </p>

                    <p className="item-info-row">
                      <span>
                        <strong>Valor à Vista:</strong>{" "}
                        {item.valor
                          ? (item.valor / 100).toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })
                          : "Não Informado"}
                      </span>

                      <span>
                        <strong>IPTU:</strong>{" "}
                        {item.iptu
                          ? (item.iptu / 100).toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })
                          : "Não Informado"}
                      </span>

                      {item.condominio && (
                        <span>
                          <strong>Condomínio:</strong>{" "}
                          {(item.condominio / 100).toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </span>
                      )}
                    </p>

                    <p className="item-info-row">
                      <span>
                        <strong>Responsável:</strong>{" "}
                        {realEstatesMap[item.real_estate_id] || "Não informado"}{" "}
                        ({item.categoriaResponsavel || "N/A"})
                      </span>

                      <span>
                        <strong>Comissão:</strong>{" "}
                        {formatarComissao(item.comissao)}
                      </span>
                    </p>

                    <p className="item-features">
                      {item.dorms && (
                        <span>{`${item.dorms} ${
                          item.dorms > 1 ? "Dorms" : "Dorm"
                        }`}</span>
                      )}

                      {item.banheiros && <span>{`${item.banheiros} WC`}</span>}

                      {item.suites && (
                        <span>{`${item.suites} ${
                          item.suites > 1 ? "Suítes" : "Suíte"
                        }`}</span>
                      )}

                      {item.garagens && (
                        <span>{`${item.garagens} ${
                          item.garagens > 1 ? "Vagas" : "Vaga"
                        }`}</span>
                      )}
                    </p>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>

      {isLoading ? (
        <div className="container-data-user-horizontal-bar">
          <p>Carregando</p>
        </div>
      ) : currentUser ? (
        <div className="container-data-user-horizontal-bar">
          <i>
            <FaUserCircle />
          </i>

          <div className="user-info-wrapper">
            <div className="field-data-horizontal-bar">
              <p className="field-label">USUÁRIO:</p>

              <p className="field-value">{currentUser.nome.toUpperCase()}</p>
            </div>

            <div className="field-data-horizontal-bar">
              <p className="field-label">NÍVEL:</p>

              <p className="field-value">{currentUser.nivel.toUpperCase()}</p>
            </div>
          </div>
        </div>
      ) : (
        <div className="container-data-user-horizontal-bar">
          <p>Usuário não encontrado.</p>
        </div>
      )}
    </header>
  );
}